function TriggersFormController(stateService, toasterService, CommonService, $uibModal, $timeout, $scope) {
  const ctrl = this;
  const swap = CommonService.swap;
  const preLoadStream = CommonService.preLoadStream;
  const getMacroList = CommonService.getMacroList;
  const checkName = CommonService.checkName;

  ctrl.$onInit = async () => {
    ctrl.workspaceId = stateService.getSelectedWorkspace().id;
    stateService.getStreams(ctrl.workspaceId).then(data => ctrl.streams = data);
    ctrl.loadVariables(ctrl.workspaceId);
    if (!ctrl.selection) {
      ctrl.trigger = {
        name: null,
        description: null,
        streams: []
      };
      ctrl.newTrigger = true;
      ctrl.viewMode = false;
    } else {
      ctrl.trigger = angular.copy(ctrl.selection);
      ctrl.viewMode = true;
    }
    if (ctrl.selection) {
      getFileUrls(ctrl.trigger.streams);
      getFileUrls(ctrl.trigger.stream_targets);
    }
  };

  ctrl.checkValidity = () => {
    return ctrl.trigger.streams.length === 0 || ctrl.duplicateName;
  };

  ctrl.toggleEditMode = value => {
    if (value) {
      ctrl.viewMode = false;
      ctrl.triggerSnapshot = angular.copy(ctrl.trigger);
    } else {
      ctrl.trigger = angular.copy(ctrl.triggerSnapshot);
      ctrl.viewMode = true;
    }
  };

  ctrl.checkDuplicate = () => {
    ctrl.duplicateName = checkName(ctrl.triggers, ctrl.trigger);
  };

  ctrl.removeStream = index => {
    ctrl.trigger.streams.splice(index, 1);
  };

  ctrl.move = (slot1, slot2) => {
    ctrl.fetchDone = false;
    ctrl.trigger.streams = swap(angular.copy(ctrl.trigger.streams), slot1, slot2);
    $timeout(() => {
      ctrl.fetchDone = true;
    }, 300);
  };

  ctrl.loadVariables = id => {
    stateService.getVariables(id).then(data => {
      ctrl.variables = data;
    });
  };

  const getFileUrls = async (streams) => {
    if (!streams) return;
    ctrl.fetchDone = false;
    const macroList = await getMacroList(ctrl.workspaceId);
    streams.map(s => {
      if (s.id !== null) {
        preLoadStream(ctrl.workspaceId, s, macroList).then(fileUrl => {
          s.file_url = fileUrl;
          $timeout(() => {
            ctrl.fetchDone = true;
          }, 100);
        });
      }
    });
  };
  
  ctrl.openStreamModal = () => {
    let modalInstance = $uibModal.open({
      component: 'streamModal',
      backdrop: 'static',
      windowClass: 'subSystemWindow',
      resolve: {
        streams: () => ctrl.streams,
      },
    });

    modalInstance.result.then(
      selectedStream => {
        // User pressed 'Yes' in the modal.
        ctrl.trigger.streams.push(selectedStream);
        getFileUrls(ctrl.trigger.streams);
        getFileUrls(ctrl.trigger.stream_targets);
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };

  ctrl.openMacroStreamModal = () => {
    let modalInstance = $uibModal.open({
      component: 'macroStreamModal',
      backdrop: 'static',
      windowClass: 'subSystemWindow',
      resolve: {
        variables: () => ctrl.variables,
      },
    });

    modalInstance.result.then(
      newMacroStream => {
        // User pressed 'Yes' in the modal.
        ctrl.trigger.streams.push(newMacroStream);
        getFileUrls(ctrl.trigger.streams);
        getFileUrls(ctrl.trigger.stream_targets);
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };

  const createNewTrigger = () => {
    stateService.createTrigger(ctrl.trigger, ctrl.workspaceId).then(
      function (response) {
        ctrl.onFormSubmit({
          $event: {
            mode: false,
          },
        });
        toasterService.success('toaster.pis-event', 'toaster.pis-create-trigger-successful');
      },
      function (e) {
        toasterService.error('toaster.pis-event', 'toaster.pis-create-trigger-failure');
        console.log(e);
      }
    );
  };

  ctrl.clearForm = () => {
    ctrl.triggerForm.$setPristine(true);
    ctrl.triggerForm.$setUntouched(true);
    ctrl.viewMode = false;
    ctrl.duplicateName = false;
    ctrl.trigger = {
      streams: [],
      name: '',
      description: '',
    };
  };

  ctrl.onSubmit = () => {
    ctrl.viewMode = true;
    if (ctrl.newTrigger) {
      createNewTrigger();
    } else {
      let editObject = {
        name: ctrl.trigger.name,
        description: ctrl.trigger.description,
        streams: ctrl.trigger.streams
      };
      stateService.editTrigger(ctrl.workspaceId, ctrl.trigger.id, editObject).then(
        function (response) {
          toasterService.success('toaster.pis-event', 'toaster.pis-edit-trigger-successful');
        },
        function (e) {
          toasterService.error('toaster.pis-event', 'toaster.pis-edit-trigger-failure');
          console.log(e);
        }
      );
    }
  };
}

angular
  .module('pis-tool.module')
  .controller('TriggersFormController', TriggersFormController);